const Button = {
    baseStyle: {
        fontWeight: '500',
        borderRadius: '4px',
        fontSize: '16px',
        lineHeight: '20px',
        _hover: {
            _disabled: {
                bg: 'gray.300',
            },
        },
        _disabled: {
            bg: 'gray.300',
            opacity: 1,
            color: 'white',
        },
    },

    sizes: {
        md: {
            p: '12px 16px',
            minHeight: '44px',
        },
        sm: {
            fontSize: '14px',
            p: '10px 14px',
            minHeight: '40px',
        },
    },
    variants: {
        primary: {
            bg: 'blue.500',
            color: 'white',
            _hover: {
                bg: 'green.500',
                _disabled: {
                    bg: 'gray.100',
                },
            },
            _disabled: {
                bg: 'gray.100',
                opacity: 1,
                color: 'gray.400',
            },
        },
        secondary: {
            bg: 'gray.100',
            color: 'gray.900',
            _hover: {
                bg: 'gray.200',
                _disabled: {
                    bg: 'gray.100',
                    color: 'gray.400',
                },
            },
            _disabled: {
                bg: 'gray.100',
                color: 'gray.400',
            },
        },
        'secondary-special': {
            bg: 'white',
            color: 'gray.900',
            _hover: {
                bg: 'gray.200',
            },
        },
        special: {
            bg: 'red.200',
            color: 'red.900',
            _hover: {
                bg: 'rgba(204, 70, 70, 0.25)', // red.900 with reduced transparency
            },
        },
        'special-green': {
            bg: 'green.900',
            color: 'white',
            _hover: {
                bg: 'green.500',
            },
        },
        ghost() {
            // @todo add hover color to button icons
            return {
                color: 'gray.600',
                _hover: { bg: 'gray.100' },
            };
        },
    },

    defaultProps: {
        variant: 'primary',
        size: 'md',
    },
};

export default Button;
